<template>
  <tr class="leaderboard-table__heading">
    <th
      v-for="headingItem in headingItems"
      class="leaderboard-table__heading-cell"
    >
      {{ headingItem.text }}
    </th>
  </tr>
</template>

<script>
  export default {
    name: 'LeaderBoardTableHead',
    props: ['headingItems']
  }
</script>

<style scoped>
  .leaderboard-table__heading {
    color: #6e8ca0;
    font-weight: 300;
    padding-bottom: 10px;
  }
  .leaderboard-table__heading-cell {
    font-weight: 300;
    text-transform: uppercase;
    font-size: 14px;
  }
</style>
